import { render } from "./LibraryRightClickBox.vue?vue&type=template&id=e189eab8&scoped=true"
import script from "./LibraryRightClickBox.vue?vue&type=script&lang=js"
export * from "./LibraryRightClickBox.vue?vue&type=script&lang=js"

import "./LibraryRightClickBox.vue?vue&type=style&index=0&id=e189eab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e189eab8"]])

export default __exports__